import type { PaymentIncident } from '@nuberu/types';

// Words for the "Pagos sin reserva" tab. Pure, so they are tested without
// rendering.

const SUBJECT: Record<PaymentIncident['subject'], string> = {
  booking: 'Reserva',
  bono: 'Bono',
  rental: 'Alquiler',
};

const REASON: Record<PaymentIncident['reason'], string> = {
  paid_not_fulfilled: 'Cobrado sin reserva',
  returned_ok_not_fulfilled: 'Volvió del banco con OK, sin confirmación de Redsys',
  refund_failed: 'Devolución fallida',
};

const RESOLUTION: Record<NonNullable<PaymentIncident['resolution']>, string> = {
  fulfilled: 'Creada',
  refunded: 'Devuelto',
  manual: 'Cerrada a mano',
};

export const subjectLabel = (incident: PaymentIncident): string => SUBJECT[incident.subject];
export const reasonLabel = (incident: PaymentIncident): string => REASON[incident.reason];
export const resolutionLabel = (incident: PaymentIncident): string =>
  incident.resolution === null ? '—' : RESOLUTION[incident.resolution];

// 17500 → "175,00 €".
export const formatMoney = (cents: number, currency: string): string =>
  new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(cents / 100);

// "2026-10-13T08:05:00.000Z" → "13 oct 2026, 10:05" in Madrid.
export const formatWhen = (iso: string): string =>
  new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Madrid',
  }).format(new Date(iso));

// Which actions an open incident offers. A failed refund is retried from
// "Colas" or refunded in the processor's panel, then marked resolved.
export const actionsFor = (
  incident: PaymentIncident,
): { readonly fulfil: boolean; readonly refund: boolean } =>
  incident.reason === 'refund_failed'
    ? { fulfil: false, refund: false }
    : { fulfil: true, refund: true };

// What to check before creating it, per processor.
export const fulfilHint = (incident: PaymentIncident): string =>
  incident.processor === 'stripe'
    ? 'Comprobamos con Stripe que el pago está cobrado antes de crearla. Si ya no hay sitio, el pago se devuelve solo y se avisa al cliente.'
    : 'Redsys no se puede consultar: confirma en el panel del banco del operador que el pago está cobrado. Si ya no hay sitio, el pago se devuelve solo y se avisa al cliente.';
